<template>
  <div v-if="size == 'normal'" class="loading-circle" :class="classes">
    <div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div v-else-if="size == 'small'" class="spinner spinner--1"></div>
</template>

<script>
export default {
  props: {
    classes : Array,
    size : {
      type: String,
      default: "normal"
    }
  },
};
</script>


<style lang="scss" scoped>
.spinner {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}
.spinner--1 {
  border-top: 2px solid #c7c7c7;
  animation: spinner1 600ms linear infinite;
}
@keyframes spinner1 {
  to {
    transform: rotate(360deg);
  }
}
</style>
